<dx-popover
  (onHidden)="datesPopoverVisible = false"
  (onShowing)="copiedUserMetricGroup = appService.deepCopy(this.dashboardService.fullSelUserMetricGroup);"
  [hideOnOutsideClick]="false"
  [visible]="datesPopoverVisible && !dashboardService.isChartDrawerOpen"
  [width]="590"
  [wrapperAttr]="{
    class: 'timeSelectorPopup'
  }"
  position="top"
  style="display: none;"
  target="#link1">
  <div *dxTemplate="let data = model; of: 'content'">

    <app-chart-time-selector
      (bucketIsValid)="bucketIsValid = $event"
      (dateIsValid)="dateIsValid = $event"
      [userMetricGroup]="copiedUserMetricGroup!"
      #chartTimeSelectorComponent>
    </app-chart-time-selector>

    <div class="rowFlexContent" style="justify-content: end; margin-top: 10px">
      <dx-button
        type="normal"
        stylingMode="text"
        (onClick)="datesPopoverVisible = false"
        text="{{'BUTTONS.CANCEL' | translate}}">
      </dx-button>
      <div class="flexFill"></div>
      <dx-button
        (onClick)="checkDateRange(); exportChart()"
        [disabled]="!dateIsValid"
        [icon]="'download'"
        stylingMode="outlined"
        [elementAttr]="{class:'redButton'}"
        hint="{{'BUTTONS.HINTS.EXPORT' | translate}}"
        text="{{'BUTTONS.EXPORT' | translate}}">
      </dx-button>
      <!-- Mostra persists the range with putUserMetricGroup, which is self-only: on someone else's
           chart there is nothing to save, and export alone stays available -->
      <dx-button
        *ngIf="!dashboardService.isImpersonatingUser()"
        type="default"
        (onClick)="checkDateRange(); saveNewDatesRangeAndReloadData()"
        [disabled]="!dateIsValid || !bucketIsValid"
        [elementAttr]="{class:'redButton'}"
        [icon]="'check'"
        text="{{'BUTTONS.SHOW' | translate}}">
      </dx-button>

    </div>
  </div>
</dx-popover>
<dx-button
  (onClick)="openDatesSelector(); $event.event!.stopPropagation()"
  *ngIf="dashboardService.selUserMetricGroup"
  [disabled]="dashboardService.isChartDrawerOpen"
  [elementAttr]="{class:'outlinedRedButton'}"
  [stylingMode]="'text'"
  hint="{{'BUTTONS.HINTS.DATE_SELECTION' | translate}}"
  id="link1">
  <i class="vr-ic_fluent_clock_24_regular"></i>
  <div *ngIf="!appService.isMediumScreen()" [innerHtml]="printDateSelectionText()" class="datesSelectionText"></div>
</dx-button>

<dx-button
  (onClick)="realReload = true; reloadChart()"
  *ngIf="dashboardService.selUserMetricGroup"
  [elementAttr]="{class:'outlinedRedButton'}"
  [stylingMode]="'text'"
  hint="{{'BUTTONS.HINTS.RELOAD_CHART' | translate}}"
  title="{{'BUTTONS.HINTS.RELOAD_CHART' | translate}}">
  <i class="vr-ic_fluent_arrow_sync_24_regular"></i></dx-button>
<dx-button
  (onClick)="createMetricGroup()"
  *ngIf="!dashboardService.isImpersonatingUser()"
  [elementAttr]="{class:'outlinedRedButton'}"
  [stylingMode]="'text'"
  hint="{{'BUTTONS.HINTS.CREATE_METRIC_GROUP' | translate}}"
  title="{{'BUTTONS.HINTS.CREATE_METRIC_GROUP' | translate}}">
  <i class="vr-ic_fluent_add_24_regular"></i>
</dx-button>
<dx-button
  (onClick)="editChart()"
  *ngIf="dashboardService.selUserMetricGroup && !dashboardService.isImpersonatingUser()"
  [elementAttr]="{class:'outlinedRedButton'}"
  [stylingMode]="'text'"
  hint="{{'BUTTONS.HINTS.OPEN_DETAIL' | translate}}"
  title="{{'BUTTONS.HINTS.OPEN_DETAIL' | translate}}">
  <i class="vr-ic_fluent_edit_24_regular"></i>
</dx-button>
